import styled from "styled-components";
import { COLORS, FONT_SIZE, FONT_WEIGHT } from "../../../constants/Styles";

const DetailBlock = styled.div`
  width: 100%;
  font-size: ${FONT_SIZE.size13};
  color: ${COLORS.secondaryLight};
`;

const DetailLine = styled.div<{
  topBorder?: boolean;
  bottomBorder?: boolean;
  isBoardBreakdown?: boolean;
}>`
  font-size: ${FONT_SIZE.size13};
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  text-wrap: balance;
  align-items: center;

  ${({ bottomBorder }) =>
    bottomBorder &&
    `
          padding-bottom: 1rem;
          border-bottom: 1px solid ${COLORS.badgeGray};
  `}

  ${({ topBorder }) =>
    topBorder &&
    `
          padding-top: 1rem;
          border-top: 1px solid ${COLORS.badgeGray};
  `}
`;

const Label = styled.div`
  font-weight: ${FONT_WEIGHT.weight400};
  display: flex;
  align-items: center;
  color: ${COLORS.secondaryLight};
`;

const ValueText = styled.div`
  font-weight: ${FONT_WEIGHT.weight500};
  color: ${COLORS.secondary};
  font-variant-numeric: tabular-nums;
`;

export const LineItemDescription = styled.div`
  font-size: ${FONT_SIZE.size12};
  color: ${COLORS.secondaryLight};
`;

export { DetailBlock, DetailLine, Label, ValueText };
